import VueRouter from 'vue-router'
import Home from './pages/Home'
import Login from './pages/auth/Login'
import Register from './pages/auth/Register'
import Questionnaire from './pages/questionnaire/Questionnaire'

import HomeLogistics from './pages/alternativePages/Logistics'
import HomeTourism from './pages/alternativePages/Tourism'
import HomeMines from './pages/alternativePages/Mines'
import HomeZones from './pages/alternativePages/Zones'

import MapPage from './pages/mapPage/MapPage'
import MapSearch from './pages/mapPage/pages/MapSearch'
import OpportunityList from './pages/mapPage/pages/OpportunityList'
import OpportunityDetail from './pages/mapPage/pages/opportunityDetail/OpportunityDetail'
import RegionalStatistics from './pages/mapPage/pages/RegionalStatistics'
import Straitigraphy from './pages/mapPage/pages/Straitigraphy'

import Logistics from './pages/mapPage/pages/logistics/Logistics'
import LandLogistic from './pages/mapPage/pages/logistics/components/LandLogistic'
import SeaLogistic from './pages/mapPage/pages/logistics/components/SeaLogistic'
import AirLogistic from './pages/mapPage/pages/logistics/components/AirLogistic'

import Lock from './pages/mapPage/pages/Lock'

import Dashboard from './pages/dashboard/Dashboard'
import CreateCampaign from './pages/dashboard/pages/createCampaign/CreateCampaign'
import TemplatePage from './pages/dashboard/pages/TemplatePage'

import Page404 from './pages/Page404'

export default new VueRouter({
	mode: 'history',
	linkActiveClass: 'active',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/login',
			name: 'login',
			component: Login
		},
		{
			path: '/register',
			name: 'register',
			component: Register
		},
		{
			path: '/questionnaire',
			name: 'questionnaire',
			component: Questionnaire
		},
		{
			path: '/logistics',
			name: 'home-logistics',
			component: HomeLogistics
		},
		{
			path: '/tourism',
			name: 'home-tourism',
			component: HomeTourism
		},
		{
			path: '/mines',
			name: 'home-mines',
			component: HomeMines
		},
		{
			path: '/zones',
			name: 'home-zones',
			component: HomeZones
		},
		{
			path: '/map',
			name: 'map',
			component: MapPage,
			children: [
				{
					path: 'search',
					name: 'map-search',
					component: MapSearch
				},
				{
					path: 'opportunity-list',
					name: 'opportunity-list',
					component: OpportunityList
				},
				{
					path: 'opportunity/:opportunityId',
					name: 'opportunity',
					component: OpportunityDetail
				},
				{
					path: 'regional-statistics',
					name: 'regional-statistics',
					component: RegionalStatistics
				},
				{
					path: 'straitigraphy',
					name: 'straitigraphy',
					component: Straitigraphy
				},
				{
					path: 'logistics',
					name: 'logistics',
					component: Logistics,
					children: [
						{
							path: 'land',
							name: 'land-logistic',
							component: LandLogistic
						},
						{
							path: 'sea',
							name: 'sea-logistic',
							component: SeaLogistic
						},
						{
							path: 'air',
							name: 'air-logistic',
							component: AirLogistic
						},
					]
				},
				{
					path: 'lock',
					name: 'lock',
					component: Lock
				}
			]
		},
		{
			path: '/dashboard',
			name: 'dashboard',
			component: Dashboard,
			children: [
				{
					path: 'create-campaign',
					name: 'create-campaign',
					component: CreateCampaign
				}
			]
		},
		{
			path: '/template/:templateId',
			name: 'template',
			component: TemplatePage
		},
		{
			path: '*',
			name: 'page404',
			component: Page404
		}
	]
})
